import React, { useState, useContext } from "react";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import Button from "../CustomButtons/Button";
import { Clear, Search, Tune } from "@mui/icons-material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import PropTypes from "prop-types";
import GridItem from "../Grid/GridItem";
import GridContainer from "../Grid/GridContainer";
import {withStyles} from "@mui/styles";
import simpleSearchStyle from "../../assets/jss/material-dashboard-pro-react/components/simpleSearchStyle";
import Input from "@mui/material/Input";
import { NativeSelect } from "@mui/material";
import CustomAdvancedSearch from "./AdvancedSearch";
import UserService from "../../services/UserService";
import { postSimpleSearch } from "../../services/ConfigServices";
import ReactLoading from "react-loading";
import AdvancedSearchContext from "../../context/AdvancedSearchContext";
import CustomSelect from "components/Input/CustomSelect";
import { fieldsearchdata } from "variables/lists/search"

function SimpleSearch(props) {

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const { setSearchedIds, handleAdvanceTree, searchedIds, searchresultindex, setSearchresultindex, scrollup, scrolldown } = props;
  const [terms, setTerms] = useState("");
  const [fields, setFields] = useState("all");
  const [resetSearch, setResetSearch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchInProgress, setSearchInProgress] = useState(false);

  const getIds = async () => {
    axios
      .post(
        postSimpleSearch(chartIdGroup),
        {
          fields: fields,
          terms: terms,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((response) => {
        setSearchInProgress(false);
        setResetSearch(true);
        setSearchresultindex(0);
        if (response.status === 200) {
          setSearchedIds(response.data);
        } else if (response.status === 401) {
          alert("unauthorized");
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
    setSearchInProgress(true);
  };

  const handleTermValueChange = (event) => {
    setTerms(event.target.value);
    setResetSearch(false);
  }

  const handleFieldsValueChange = (event) => {
    setFields(event.target.value);
    setResetSearch(false);
  }

  const handleResetSearch = () => {
    setTerms("");
    setSearchresultindex(0);
    setResetSearch(false);
    setSearchedIds([]);
  };

  const getAdvancedResultTree = () => {
    setOpenModal(false);
    handleAdvanceTree();
  };

  const handleHideAdvancedSearch = () => {
    setOpenModal(false);
  };

  const handleAdvancedSearch = () => {
    setOpenModal(true);
  }


  const { classes } = props;
  return (
    <>
      <div className={classes.searchBox}>
        <div className={classes.itemGrid1}>
          <Input
            className={classes.inputSearch}
            value={terms}
            name={"terms"}
            placeholder={"Rechercher..."}
            onChange={handleTermValueChange}
            disableUnderline={true}
          />
        </div>
        <div item={"true"} xs={6} md={2} lg={1}>
          {resetSearch ? (
            <>
              {/* <ArrowDropUpIcon> </ArrowDropUpIcon>

                <ArrowDropDownIcon> </ArrowDropDownIcon> */}
              {/* <Button
                  type="button"
                  name="resetSearch"
                  color="danger"
                  size={"sm"}
                  round
                  justIcon
                  className={classes.cancelButton}
                  onClick={this.props.nextItem}
                >
                  <ArrowDropDownIcon> </ArrowDropDownIcon>
                </Button> */}
              <Button
                type="button"
                name="resetSearch"
                color="danger"
                size={"sm"}
                round
                justIcon
                className={classes.cancelButton}
                onClick={handleResetSearch}
              >
                <Clear> </Clear>
              </Button></>
          ) : !searchInProgress ? (
            <Button
              type="submit"
              color="success"
              round
              justIcon
              onClick={getIds}
              className={classes.searchBtn}
              disabled={!terms}
            >
              <Search className={classes.search}> </Search>
            </Button>
          ) : <Button
            type="submit"
            color="info"
            round
            justIcon
            className={classes.searchBtn}
          >
            <ReactLoading
              type={"balls"}
              color={"#FFFFFF"}
              height={"100%"}
              width={"30px"}
              style={{ marginLeft: "0%", marginTop: "0px", height: "100%", width: "30px", fill: "#FFFFFF" }}
            />
          </Button>}
        </div>
        <div>
          <Button
            type="button"
            name="advancedSearch"
            size={"sm"}
            round
            justIcon
            className={classes.advanceBtn}
            onClick={handleAdvancedSearch}
          >
            <Tune> </Tune>
          </Button>
        </div>
        <CustomAdvancedSearch
          open={openModal}
          handleHideAdvancedSearch={handleHideAdvancedSearch}
          // handleCloseSearch={handleCloseSearch}
          getAdvancedResultTree={() => getAdvancedResultTree()}
        />
      </div>

      <GridContainer>
        <GridItem xs={8} lg={8} className={classes.itemGrid2}>
          {
            resetSearch ?
              <>
                <div style={{ height: "31px", marginTop: "0px", display: "flex" }}>
                  <div className={classes.searchResult}>{""+searchresultindex+"/"+searchedIds.length}</div>
                  <ArrowDropUpIcon onClick={scrollup} className={classes.scrollButton}> </ArrowDropUpIcon>
                  <ArrowDropDownIcon onClick={scrolldown} className={classes.scrollButton}> </ArrowDropDownIcon>
                </div>
              </>
              :
              <div>
                <CustomSelect
                  inputTitle={""}
                  selectValue={fields}
                  handleSelectValueChange={handleFieldsValueChange}
                  data={fieldsearchdata}
                  search
                />
              </div>
          }

          {/* <FormControl fullWidth className={classes.selectFormControl}>
            <NativeSelect
              // style={{ width: "160px" }}
              value={fields}
              className={classes.selectField}
              onChange={handleFieldsValueChange}
              inputProps={{ name: "fields", id: "fields" }}
              // ref={selectField}
              disableUnderline={true}
            >
              <option className={classes.optionField} value={"all"}>
                Tous les champs
              </option>
              <option className={classes.optionField} value={"name"}>
                Nom
              </option>
              <option className={classes.optionField} value={"address"}>
                Adresse
              </option>
              <option className={classes.optionField} value={"pdl"}>
                Pdl
              </option>
            </NativeSelect>
          </FormControl> */}
        </GridItem>
      </GridContainer>
    </>
  );

}

export default withStyles(simpleSearchStyle)(SimpleSearch);

SimpleSearch.propTypes = {
  handleSearch: PropTypes.func,
  handleCancelSearch: PropTypes.func,
  handleAdvanceTree: PropTypes.func,
  ids: PropTypes.arrayOf(PropTypes.string),
  classes: PropTypes.object,
};
